import { __awaiter } from 'tslib';
import { isEmpty } from 'lodash';
import { jsonParse, jsonStringify } from './json.js';

function paramsToQueryString(params = {}) {
    return Object.entries(params)
        .filter(param => param[1] !== undefined)
        .map(param => `${param[0]}=${param[1]}`)
        .join("&");
}
const fixUrl = (url) => url.replaceAll('#', '%23');
function fetchGet(url, params = {}, options) {
    return __awaiter(this, void 0, void 0, function* () {
        if (url.includes("undefined"))
            console.log(url);
        const { fallback } = options || {};
        const queryString = paramsToQueryString(params);
        const urlWithParams = `${url}${queryString ? (url.includes('?') ? '&' : '?') + queryString : ''}`;
        // console.log('fetchGet', urlWithParams)
        return fetch(fixUrl(urlWithParams), { method: 'GET', cache: 'no-store' }).then((res) => __awaiter(this, void 0, void 0, function* () {
            if (res.ok) {
                return jsonParse(yield res.text());
            }
            else {
                console.error(res.status, res.statusText);
                return fallback;
            }
        }));
    });
}
function fetcher(url, method, body = {}, queryParams = {}, fallback) {
    return __awaiter(this, void 0, void 0, function* () {
        const res = yield fetch(fixUrl(`${url}?${paramsToQueryString(queryParams)}`), Object.assign(Object.assign({ method, headers: { "Content-Type": "application/json" } }, (!isEmpty(body) && { body: jsonStringify(body) })), { cache: 'no-store' })).then((res) => __awaiter(this, void 0, void 0, function* () {
            if (res.ok) {
                const text = yield res.text();
                if (text.toLowerCase().startsWith('success'))
                    return fallback;
                return jsonParse(text);
            }
            else {
                // console.error(res.status, res.statusText);
                return fallback;
            }
        })).catch((err) => {
            // console.error(err);
            return fallback;
        });
        return res;
    });
}

export { fetchGet, fetcher, paramsToQueryString };
